import mirrorCreator from "mirror-creator";

export default mirrorCreator([
    "GET_ALL_FUEL_CARDS",
    "GET_UNLINKED_FUEL_CARDS",
    "GET_DRIVER_FUEL_CARDS",
    "GET_CAR_FUEL_CARDS",
    "SET_FUEL_CARDS_LOADING",
    "MERGE_FUEL_CARDS_PARAMS",
]);
